import React, {useCallback, useState} from "react";
import {Row, Col, Form, theme as configTheme, Select} from "antd";
import cl from 'classnames'
import {LockOutlined, UserOutlined} from "@ant-design/icons";
import {LanguageDefaultSwitch, MyButton, MyImage, MyInput, MyPassword, MyText} from "../../components";
import AuthImage from '../../assets/images/auth-image.png'
import {useAuth} from "../../hooks";
import {AuthPage, LeftCol, RightCol} from "./index.styles";
import {useSelector} from "react-redux";
import {MyAliasToken} from "../../assets/themes/defaultTheme";
import {RootState} from "../../store";
import {selectStore} from "../../store/selector";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import {ROUTE_PATH} from "../../constants";
import {RightArrowIcon} from "../../assets";

const {useToken} = configTheme

export const Auth = (): React.ReactElement => {
  const {t} = useTranslation("common")
  const navigate = useNavigate();

  const [isImageLoad, setIsImageLoad] = useState(false)

  const {handleLogin} = useAuth()

  const [authForm] = Form.useForm()

  // @ts-ignore
  const {token}:{token: MyAliasToken} = useToken();

  const {profile: {userProfile: profileDataState}}: RootState = useSelector(selectStore)

  const onFinish = useCallback((values: any) => {
    handleLogin(values)
  }, [])

  const handleRegisterRedirect = () => navigate(ROUTE_PATH.ENTRANT_REGISTER)

  const handleNavigate = (path: string) => navigate(path)

  const initialState= {
    username: 'director',
    password: 'a9nGXSG8',
  }


  return (
    <AuthPage>
      <LeftCol span={12}>
        <MyImage
          className={cl(isImageLoad ? 'imageVisible' : 'imageHidden')}
          src={AuthImage} width='100%' height='100%' alt='image'
          onLoad={() => setIsImageLoad(true)}/>
      </LeftCol>
      <RightCol span={12}>
        <Row style={{height: '100%'}}>
          <Col span={24}>
            <Row justify='end'>
              <Col>
                <LanguageDefaultSwitch/>
              </Col>
            </Row>
          </Col>

          <Col span={24}>
            <Row>
              <Col span={24} style={{marginBottom: 16}}>
                <Row justify='center' align='middle'>
                  <Col span={24} style={{marginBottom: 16}}>
                    <MyText align='center' size={30} color={token.primary} weight={600} style={{display: 'block'}}>
                      {t('welcome')}
                    </MyText>
                  </Col>
                  <Col span={24}>
                    <MyText align='center' size={18} color={token.subtitle} weight={600} style={{display: 'block'}}>
                      {t('loginAndPasswordEnter')}
                    </MyText>
                  </Col>
                </Row>
              </Col>
              <Col span={24}>
                <Row align='middle' justify='center'>
                  <Col span={24}>
                    <Form onFinish={onFinish} form={authForm}>
                      <Form.Item
                        label={t('login')}
                        name="username"
                        labelCol={{
                          span: 24,
                        }}
                        wrapperCol={{
                          span: 24,
                        }}
                      >
                        <MyInput prefix={<UserOutlined/>} placeholder={t('enterLogin')}/>
                      </Form.Item>

                      <Form.Item
                        label={t('password')}
                        name="password"
                        labelCol={{
                          span: 24,
                        }}
                        wrapperCol={{
                          span: 24,
                        }}
                        style={{marginBottom: 32}}
                      >
                        <MyPassword prefix={<LockOutlined/>} placeholder={t('enterPassword')}/>
                      </Form.Item>

                      <Form.Item >
                        <MyButton width='100%' height={40} type="primary" htmlType="submit" title={t('signIn')} loading={profileDataState.loading}/>
                      </Form.Item>

                      <Form.Item style={{marginBottom: 32}}>
                        {/*todo: need to translate*/}
                        <MyButton ghost onClick={() => handleRegisterRedirect()} width='100%' height={40} type="primary" title={"Зарегистрироваться"}/>
                      </Form.Item>

                      <Form.Item>
                        <MyButton ghost width='100%' height={40} type="primary" title={t('connectNewOrganization')}/>
                      </Form.Item>

                      <Row onClick={() => handleNavigate(ROUTE_PATH.ENTRANT_INFO)} align="middle" justify="space-between" style={{border: "1px solid #D7D7D7", padding: "24px 28px", borderRadius: 8, boxShadow: "0px 1px 2px 0px #00000014"}}>
                        <Col><MyText color="#000000" lineHeight="20px" >Информация о ходе проведения приемной компании</MyText></Col>
                        <Col><MyButton type="primary" children={<RightArrowIcon />} style={{borderRadius: 50, width: 48, height: 48, boxShadow: "0px 4px 4px 0px #B1986E33"}}/></Col>
                      </Row>
                    </Form>
                  </Col>

                  
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
      </RightCol>
    </AuthPage>
  )
}